import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import StaggeredAnimation from '../../components/ui/staggered-animation';

const Settings = () => {
  return (
    <div className="space-y-6">
      <StaggeredAnimation delay={100} animation="fadeUp">
        <div>
          <h1 className="text-3xl font-bold text-foreground">⚡ Settings</h1>
          <p className="text-muted-foreground">Theme, integrations, roles & permissions</p>
        </div>
      </StaggeredAnimation>

      <StaggeredAnimation delay={200} animation="fadeUp">
        <Card>
          <CardHeader>
            <CardTitle>Settings Dashboard</CardTitle>
            <CardDescription>Theme, integrations, roles & permissions</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">Settings content will be displayed here...</p>
          </CardContent>
        </Card>
      </StaggeredAnimation>
    </div>
  );
};

export default Settings;